import { Guid } from '@app/types';
import { BusinessAttributes, createEmptyBusinessAttributes } from './business-attributes';
import { NewsletterTimestamp } from './newsletterTimestamp';
import { Address, createEmptyAddress } from '@app/models/addresses/address.interface';

export class User {
    id: Guid = '';
    email: string = '';
    password: string = '';
    address: Address = createEmptyAddress();
    country: string = '';
    countryCode: string = '';
    language: string = '';
    languageCode: string = '';
    locale: string = '';
    firstName: string = '';
    lastName: string = '';
    gender: string = '';
    businessType: string = '';
    nameOfBusiness: string = '';
    phoneNumber: string = '';
    yearOfBirth: number = 0;
    newsletterTimestamps: NewsletterTimestamp[] = [];
    showWelcome: boolean = false;
    isPrivatePerson: boolean = true;
    wantsNewsletter: boolean = false;
    marketingPurposes: boolean = false;
    isAddressValidated: boolean = false;
    acceptTermsOfUse: boolean = false;
    businessAttributes: BusinessAttributes = createEmptyBusinessAttributes();
}
